// @flow

import * as React from 'react';

import { InputTextFieldGroup, useBasicValidators } from '@gandi/form/FinalForm';
import { useTranslator } from '@gandi/translate';
import { Block, BlockContent, BlockHeading } from '@gandi/ui';

import { CERT_CN_INPUT_NAME } from '../../consts';

import styles from './CNOption.scss';

const cnProps = { className: styles.input };

export function StoredCertCNOption(): React.MixedElement {
  const { __ } = useTranslator();
  const { required } = useBasicValidators();

  return (
    <Block>
      <BlockHeading>{__('Common name (CN)')}</BlockHeading>
      <BlockContent>
        <InputTextFieldGroup
          name={CERT_CN_INPUT_NAME}
          readOnly
          validate={required}
          controlPropsExtra={cnProps}
          validateFields={[]}
        />
      </BlockContent>
    </Block>
  );
}
